import type { Merchant } from '~entities/merchant';
import type { Pos } from '~entities/pos';

import type { MultiSelectOption } from '~shared/ui/multi-select-filter';

export function getMerchantOptions(merchants: Merchant[]): MultiSelectOption[] {
  return merchants.map(({ id, name }) => ({ value: id, label: name }));
}

export function getStoreOptions(
  posList: Pos[],
  selectedMerchantIds: string[]
): MultiSelectOption[] {
  const merchantIdSet = new Set(selectedMerchantIds);
  const stores = selectedMerchantIds.length
    ? posList.filter((pos) => merchantIdSet.has(pos.merchantId))
    : posList;

  return stores.map((pos) => ({ value: pos.id, label: pos.name }));
}
